(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["higvr-straps-language"] && !Shopify.designMode) return;
  try {
    (function() {
  function syncLanguageReturnTo(form) {
    var input = form.querySelector('input[name="return_to"]');
    if (input) input.value = window.location.pathname + window.location.search;
  }
  document.addEventListener('change', function(event) {
    var select = event.target;
    if (!select.matches || !select.matches('[data-higvr-language] select[name="language_code"]')) return;
    syncLanguageReturnTo(select.form);
    select.form.requestSubmit();
  });
  document.addEventListener('submit', function(event) {
    var form = event.target;
    if (form.matches && form.matches('.higvr-language-form')) syncLanguageReturnTo(form);
  });
})();
  } catch(e) { console.error(e); }
})();

})();
